import Plugin from '../Plugin'


export default class Stamps extends Plugin {

    constructor(network) {
        super(network)

        this.events = {
            'stamps_result': this.stampsResult,
            'stamp_earned': this.stampEarned
        }

        this.pendingLocal = new Set()
    }

    stampsResult(args) {
        const stampbook = this.interface.widgets?.getWidget('Stampbook')
            ?? this.interface.loadedWidgets?.Stampbook

        if (!stampbook) return

        stampbook.onResult(args)
    }

    stampEarned(args = {}) {
        const rawId = args.stamp !== undefined ? args.stamp : args.stampId
        const stampId = parseInt(rawId, 10)

        if (!Number.isFinite(stampId)) {
            return
        }

        const source = args.source === 'ruffle' ? 'ruffle' : 'server'

        const wasPending = this.pendingLocal.has(stampId)

        if (source === 'ruffle') {
            this.pendingLocal.add(stampId)
        }

        const stampInfo = this.world.stampController.getStamp(stampId)
        const stampName = stampInfo?.name || 'Stamp Earned'
        const stampCategory = stampInfo?.type ?? 3
        const stampRank = stampInfo?.rank ?? 1

        if (source === 'server') {
            this.pendingLocal.delete(stampId)
        }

        const shouldShowPrompt = source !== 'server' || !wasPending

        if (shouldShowPrompt && this.interface?.prompt) {
            this.interface.prompt.showStamp(stampName, stampCategory, stampRank)
        }

        if (source === 'server' && !this.world.client.stamps.includes(stampId)) {
            this.world.client.stamps.push(stampId)
        }
    }

}
